import request from '@utils/request';

/**
 * 首页
 * @returns {*}
 */
export function getHomeData() {
    return request.get('index', {}, { login: false });
}
/**
 * 文章列表
 * @returns {*}
 */
export function getArticleList(q, cid) {
    return request.get('article/lists/' + cid, q, { login: false });
}
/**
 * 文章详情
 * @returns {*}
 */
export function getArticleDetails(id) {
    return request.get('article/detail/' + id, {}, { login: false });
}
/**
 * 发送验证码
 * @param {*} q
 */
export function sendSmsVerify(q) {
    return request.get('verify/send', q, { login: false });
}
/**
 * 验证验证码是否正确
 * @param {*} data
 * @returns
 */
export function verifySmsCode(data) {
    return request.post('verify', data, { login: false });
}
/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function getWechatConfig() {
    return request.get('wechat/config', { url: document.location.href }, { login: false });
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function wechatAuth(code, spread, login_type) {
    return request.get('wechat/auth', { code, spread, login_type }, { login: false });
}
/**
 * 分享
 * @returns {*}
 */
export function getShare() {
    return request.get('share', {}, { login: false });
}
/**
 * 课堂瞬间
 * @returns
 */
export function getClassRoomData() {
    return request.get('classroom', {}, { login: false });
}
/**
 * 场馆首页参数
 * @returns
 */
export function getVenueData() {
    return request.get('venue', {}, { login: false });
}
